// extracted by mini-css-extract-plugin
module.exports = {"slideContainer":"Carousel_slideContainer__EmRTh","mobileHeight":"Carousel_mobileHeight__J5sr8","desktopHeight":"Carousel_desktopHeight__Yp69y"};